import type { ComponentPropsWithRef, ReactNode } from 'react'

export interface BookingFormTitleProps extends ComponentPropsWithRef<'div'> {
    children?: ReactNode
}

export function BookingFormTitle({
    children,
    className = '',
    ...restProps
}: BookingFormTitleProps) {
    return (
        <div
            {...restProps}
            className={`text-lg text-gray-700 font-semibold ${className}`.trim()}
        >
            {children}
        </div>
    )
}
